import { Directive, EventEmitter, Input, Output } from '@angular/core';

@Directive()
// tslint:disable-next-line
export abstract class AbstractWidget {
  @Output() onRefresh: EventEmitter<any> = new EventEmitter();
  @Input() widgetTitle: string;
  @Input() isLoading: boolean;

  refresh() {
    this.onRefresh.emit();
  }
}
